import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { Row, Form, Button } from 'react-bootstrap';
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const SignInActions = require('../../actions/sign_in_actions');
const SignInStore = require('../../stores/SignInStore');
const KeyboardUtil = require('../../util/keyboard');
import Navigator from '../../Navigator';
import ErrorBox from './ErrorBox';

const propTypes = {
    history: PropTypes.object.isRequired,
    forceTransition: PropTypes.bool, //set this true if requiring component from outside of SignedOut route (see main.js)
    forwardTo: PropTypes.string,
    className: PropTypes.string,
    hideRemember: PropTypes.bool,
    hideForgot: PropTypes.bool,
};

const defaultProps = {
    forceTransition: false,
    forwardTo: '',
    className: '',
    hideRemember: false,
    hideForgot: false,
};

class SignInForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            password: "",
            staySignedIn: false,
            signInStoreState: SignInStore.getState(),
            actionId: null,
            error: null,
            uiErrors: {},
        };

        this.emailOnChange = this.emailOnChange.bind(this);
        this.passwordOnChange = this.passwordOnChange.bind(this);
        this.staySignedInOnChange = this.staySignedInOnChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.signInHandler = this.signInHandler.bind(this);

        this.unsubscribes = [SignInStore.listen(this.onSignInStoreChange.bind(this))];
    }

    componentDidUpdate() {
        if (!this.state.signInStoreState.signedIn) {
            //todo: parse form errors
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onSignInStoreChange(state) {
        if (this.props.forceTransition && state.initializedLocal) {
            console.log('SignInForm onSignInStoreChange (forceTransition) doing transition (using "replace")');
            if (this.props.forwardTo) {
                this.props.history.push(this.props.forwardTo);
            }
            else {
                Navigator.goToDashboardHome(this.props.history);
            }

            return;
        }

        let additionalState = {};
        if (state.action.id === this.state.actionId) {
            additionalState = { ...additionalState, actionId: null };
            if (state.action.error) {
                let uiErrors = {};
                if (state.action.error.uiRefs) {
                    state.action.error.uiRefs.forEach((ref) => {
                        uiErrors[ref] = true;
                    });
                }

                additionalState = {
                    ...additionalState,
                    error: state.action.error,
                    uiErrors: uiErrors
                }
            }
        }

        this.setState({ signInStoreState: state, ...additionalState });
    }

    emailOnChange(e) {
        this.setState({ email: e.target.value, hasError: false });
    }

    passwordOnChange(e) {
        this.setState({ password: e.target.value, hasError: false });
    }

    staySignedInOnChange(e) {
        this.setState({ staySignedIn: e.target.value });
    }

    handleKeyDown(e) {
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            this.signInHandler();
        }
    }

    signInHandler() {
        const actionId = uuid.v4();
        this.setState({ actionId: actionId }, () => {
            SignInActions.signIn(actionId, {
                email: this.state.email,
                password: this.state.password,
                staySignedIn: this.state.staySignedIn
            });
        });
    }

    render() {
        return (
            <div className={this.props.className}>
                <ErrorBox error={this.state.error} />
                <Form>
                    <Form.Group controlId="signin-email">
                        <Form.Label>{Strings['en'].signed_out.sign_in_new.form.EMAIL}</Form.Label>
                        <Form.Control
                            type="email"
                            aria-label={Strings['en'].signed_out.sign_in_new.form.EMAIL}
                            onChange={this.emailOnChange}
                            onKeyDown={this.handleKeyDown}
                            isInvalid={this.state.uiErrors['email']}
                        />
                    </Form.Group>
                    <Form.Group controlId="signin-password">
                        <Form.Label>{Strings['en'].signed_out.sign_in_new.form.PASSWORD}</Form.Label>
                        <Form.Control
                            type="password"
                            autoComplete="off"
                            aria-label={Strings['en'].signed_out.sign_in_new.form.PASSWORD}
                            onChange={this.passwordOnChange}
                            onKeyDown={this.handleKeyDown}
                            isInvalid={this.state.uiErrors['password']}
                        />
                    </Form.Group>
                    {(!this.props.hideRemember || !this.props.hideRemember) &&
                        <div className="signedOutDual__formRememberForgot margin-top-lg">
                            {(!this.props.hideRemember) &&
                                <label className="label-form">
                                    <input type="checkbox" onChange={this.staySignedInOnChange} /> {Strings['en'].signed_out.sign_in_new.form.REMEMBER_ME}
                                </label>
                            }
                            {(!this.props.hideForgot) &&
                                <Link className="fr" to='/request_password_reset'>{Strings['en'].signed_out.sign_in_new.form.FORGOT}</Link>
                            }
                            
                        </div>
                    }
                    <div className="signedOutDual__buttonRow margin-top-lg">
                        <Button
                            disabled={this.state.actionId}
                            onClick={this.signInHandler}
                        >
                            {Strings['en'].signed_out.sign_in_new.form.SIGN_IN}
                        </Button>
                    </div>
                </Form>
            </div>
        );
    }
}

SignInForm.propTypes = propTypes;
SignInForm.defaultProps = defaultProps;

export default withRouter(SignInForm);